import { Container, ScoreWrapper, Icon, DescWrapper, TitleWrapper } from './IndexCardStyles';
import QuestionIcon from '@/ui/icon/questionIcon/QuestionIcon';
import { cn } from '@/lib/utils';

interface IndexCardProps {
  title?: string;
  icon?: string;
  score?: string | React.ReactNode;
  desc?: string;
  explanation?: string;
}

const IndexCard = ({ title, icon, score, desc, explanation }: IndexCardProps) => {
  return (
    <Container>
      <TitleWrapper>
        <div>{title}</div>
        {explanation ? <QuestionIcon desc={explanation} /> : null}
      </TitleWrapper>
      <ScoreWrapper>
        {icon ? <Icon src={icon} alt="icon" /> : null}
        {score ? <>{score}</> : <></>}
      </ScoreWrapper>
      <DescWrapper>
        <div className={cn(`text-text-400 text-sm`)}>{desc ? <>{desc}</> : <></>}</div>
      </DescWrapper>
    </Container>
  );
};

export default IndexCard;
